import { useContext, cloneElement } from 'react'
import NextLink from 'next/link'
import { State } from './Layout'

export default function Link( props ) {
	return props.href === '/products' ? (
		<ProductsLink {...props} />
	) : (
		<NormalLink {...props} />
	)
}

const NormalLink = props => <NextLink {...props} scroll={false} legacyBehavior />

const ProductsLink = ( props ) => {
	const { setFlyout } = useContext( State )
	const openCollectionsMenu = e => {
		if ( isSpecialClick( e ) ) return
		e.preventDefault()
		setFlyout( 'collections' )
	}

	return (
		<NextLink {...props} legacyBehavior>
			{cloneElement( props.children, { onClick: openCollectionsMenu })}
		</NextLink>
	)
}

const isSpecialClick = e => {
	// This bit is copied from Next JS's linkClicked function
	// https://github.com/vercel/next.js/blob/master/packages/next/client/link.tsx
	const { nodeName, target } = e.currentTarget as HTMLAnchorElement
	if (
		nodeName === 'A' &&
		( ( target && target !== '_self' ) ||
			e.metaKey ||
			e.ctrlKey ||
			e.shiftKey ||
			( e.nativeEvent && e.nativeEvent.which === 2 ) )
	) {
		// ignore click for new tab / new window behavior
		return true
	}
}
